module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAThJREFUeNp0kj1Lw1AUhu+9WfwJ+dj0F+Rj7yIS20EQBwdBcHDXReggCg6dirq5CFLoIA666CJCBweHJJMKnRyE/AEnkcTnSFpCWi8ccu55n/fm3A8riqI127aP8jy/VUqVav6wgiAYep73Y4qi+KQQh2E4EGEeXGmxsCZN00RrHVPoIFzyNTXYVLWOMML+iUmSvFBol2W5DnBBSUtILjXRhFGVMB2+77eMMfekV1VpmzbaWZaNJoxuNoxpGdOD5MCrwI913TQN/H6FNgoJyWdOoD7h6E6A9kk3iGvyvuM4Cxz504yBDR4CdFl5k9O4AxoDv1E7dV1XMx9NDcAHfI6Bt4BvJosAvWMaYzrD9M382eKm99B6bHCHDQ6bPQO98hI+MJ1j+pKbXiJ2gQf/PAslmjB0sPgrwAAsAJK7cMacPQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/12.png
// module id = FUCY
// module chunks = 1